// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"4219":"e941cf65d72c8dc2","4220":"4f66c7af5552bcc6"}[chunkId] + ".css";
};